enum FlowType {
  KYC = 'KYC',
  KYB = 'KYB',
  KYB_COMPANY = 'KYB_COMPANY',
  KYB_USER = 'KYB_USER',
  KYB_DIRECTOR = 'KYB_DIRECTOR'
}
export default FlowType
